window.console.log('%c' + theme_object.messages.realisation_by, 'background: #191919; padding: 10px; color: #ffffff');

document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.remove('notransition');

    setTimeout(function () {
        document.querySelectorAll('.gform_wrapper').forEach(function (form) {
            form.style.display = ''; // Removes inline display: none
        });
    }, 100);    

    const bookings_form_button = document.querySelector('.single-product-destination .help-section .wc-bookings-booking-form-button');
    if (bookings_form_button) {
        bookings_form_button.addEventListener('click', function(e) {
            e.preventDefault();
            
            const bookings_form = document.querySelector('form.cart');
            if (bookings_form) {
                const selectFields = bookings_form.querySelectorAll('select.lef-epo__field-input');
                var emptySelects = 0; 

                if (selectFields.length > 0) {
                    selectFields.forEach(function (selectField) {
                        if (selectField.value == '') {
                            emptySelects++;
                            selectField.classList.add('error');
                        }
                    });
                }

                if (emptySelects <= 0) {
                    bookings_form_button.setAttribute('disabled', '');
                    bookings_form.submit();
                } 
            }
        });
    }

    var mobile_filters = document.querySelectorAll('.mobile-filter');
    if (mobile_filters) {
        mobile_filters.forEach(function (mobile_filter) {
            var mobile_filter_toggle = mobile_filter.querySelector('.toggle-mobile-filter');
            
            if (mobile_filter_toggle) {
                mobile_filter_toggle.addEventListener('click', function(button) {
                    var toggled = mobile_filter_toggle.classList.contains('bg-black');
                    var filter = mobile_filter.querySelector('[data-lef-filter-filter]');
                    
                    if (toggled) {
                        filter.style.display = 'none';
                        mobile_filter_toggle.classList.remove('bg-black');
                        mobile_filter_toggle.classList.add('bg-primary');
                    } else {
                        filter.style.display = 'block';
                        mobile_filter_toggle.classList.remove('bg-primary');
                        mobile_filter_toggle.classList.add('bg-black');
                    }
                });
            }
        });
    }
});